<template>
  <div class="TextHighlightContentBlock">
    <div class="bg-white">
      <div class="grid">
        <div class="col-4-12 sm-col-1-1 sm-double-gutter">
          <UIHeadingType
            v-if="content.title"
            class="sm-mb-xxxlg"
            :heading-type="content.seoHeadingtype"
            :title="content.title"
          />
        </div>
        <div class="col-4-12 push-3-12 sm-col-1-1 sm-push-0 sm-double-gutter">
          <div
            class="raw mb-lg"
            v-html="content.text"
          />

          <div class="btn-container">
            <UIContentblockButton
              class="btn-primary"
              :name="content.linkObject?.name"
              :link="content.linkObject?.link"
              :target="content.linkObject?.target"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { TextOneColumnContent } from '@/types/contentblocks'
  import type { ElocusPage, BreadCrumb } from '@tc8l/nuxt-base'

  defineProps<{
    content: TextOneColumnContent
    breadCrumb?: BreadCrumb[]
    settings?: ElocusPage
    contentblockIdx?: number
  }>()
</script>

<style lang="scss" scoped>
  .TextHighlightContentBlock {
    padding: calc($gutter * 1.5);

    .bg-white {
      width: 100%;
      margin: 0 auto;
      background-color: $white;
      border-radius: var(--border-radius-lg);
      padding: calc(var(--contentblock-margin) - $gutter) 0;
    }
  }

  @include media(sm) {
    .TextHighlightContentBlock {
      padding: calc($gutter * 2);
    }

    .sm-double-gutter {
      margin: 0 $gutter;
    }
  }
</style>
